module.exports = __webpack_public_path__ + "img/case_2.f5cd9c50.png";